export default {"src":"/_next/static/media/PROJECT_DETAILS_ICON.dd9f09fd.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};